import {inlineError} from '@s-ui/decorators'

import AdvertisingRepository from './AdvertisingRepository.js'

export default class EmptyAdvertisingRepository extends AdvertisingRepository {
  @inlineError
  displayAds() {}
}
